var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38.04",
    width: 38,
    height: 38.04,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#35b0f3",
    x: 1,
    y: 1,
    width: 36,
    height: 36,
    rx: 2.57
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path11",
    fill: "#833007",
    d: "M37 3.57v30.86A2.58 2.58 0 0 1 34.43 37h-11.7V1h11.7A2.58 2.58 0 0 1 37 3.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22 1v36h1.5V1z",
    id: "path13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    fill: "#fff",
    d: "M11.38 11.31a2.88 2.88 0 0 0-2.89 2.49l-.62 6.38a2.78 2.78 0 0 0 .26 1.31L11 27.8v.2a149.3 149.3 0 0 0-1.7 4.23c-.14.37.12 1.17.82 1.57.7.41 1.74.29 2.2-1.03.28-.83.74-2.04 1.06-2.9l1.1 7.13h.57l-1.26-8.22.41-1.12c.1-.18 0-.54 0-.54L12.9 23h3.72c.1 0 .19 0 .24.12l2.23 3.49c1.04 1.39 3.25.32 2.79-1.36 0-.14-.1-.27-.16-.39L19 20.52a1.58 1.58 0 0 0-1.27-.69l-4.33-.11a.28.28 0 0 1-.27-.31l.42-3.95c0-.2.23-.31.41-.22l1.89.79c.16.1.33.1.5.1l4.53-.6c1.48-.33 1.21-2.51-.3-2.47h-.1l-3.88.5h-.16l-3.95-2a2.85 2.85 0 0 0-1.11-.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    id: "path17",
    d: "M11.81 10.34a2.37 2.37 0 1 0-3.12-1.21 2.37 2.37 0 0 0 3.12 1.21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.03,
    fill: "#fff",
    d: "M6.12 20.52s-1.49.72-.88 1.54 2 .62 2 .15-1.12-1.69-1.12-1.69z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVertical);
export default __webpack_public_path__ + "static/media/vertical.c781d3dc36bc8ca2a3411ae04877dfe2.svg";
export { ForwardRef as ReactComponent };